<template>
  <div class="mshd">
    <!-- 头部 -->

    <Head style="
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.6) 75%, #ffffff00 25%);
    box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;
    -webkit-box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;"></Head>

    <div class="left_box">
      <div class="bgc box_1">
        <div class="box_title">红色故事</div>
        <div class="box_txt">
          <ul v-show="inherit_nameList.length != 0">
            <li v-for="(item,index) in inherit_nameList"
                :key="index"
                @click="gushi(item.burg_id)">{{item.inherit_name}}</li>
          </ul>
          <span v-show="inherit_nameList.length == 0">暂无调研数据</span>
        </div>
      </div>
      <div class="bgc box_2">
        <div class="box_title">团结故事</div>
        <div class="box_txt">
          <ul v-show="unity_nameList.length != 0">
            <li v-for="(item,index) in unity_nameList"
                :key="index"
                @click="gushi(item.burg_id)">{{item.unity_name }}</li>
          </ul>
          <span v-show="unity_nameList.length == 0">暂无调研数据</span>
        </div>
      </div>
      <div class="bgc box_3">
        <div class="box_title">当地传说</div>
        <div class="box_txt">
          <ul v-show="folklore_nameList.length != 0">
            <li v-for="(item,index) in folklore_nameList"
                :key="index"
                @click="gushi(item.burg_id)">{{item.folklore_name}}</li>
          </ul>
          <span v-show="folklore_nameList.length == 0">暂无调研数据</span>
        </div>
      </div>
      <div class="bgc box_4">
        <div class="box_title">非遗</div>
        <div class="box_txt">
          <ul v-show="relic_nameList.length != 0">
            <li v-for="(item,index) in relic_nameList"
                :key="index"
                @click="feiYi(item.burg_id)">{{item.relic_name}}</li>
          </ul>
          <span v-show="relic_nameList.length == 0">暂无调研数据</span>
        </div>
      </div>
    </div>

    <RightBox_2></RightBox_2>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import RightBox_2 from '@/components/RightBox_2.vue'
import bus from '../../utils/bus.js'

export default {
  components: {
    Head, RightBox_2
  },
  data () {
    return {
      spanArr: [],
      pos: '',
      dialogName: '',
      pathName: '',
      dialogVisible: false,
      city_id: '0',
      inherit_nameList: [],
      unity_nameList: [],
      folklore_nameList: [],
      relic_nameList: [],
    }
  },
  mounted () {
    this.getData()

    bus.$on('mapBus', (date) => {
      this.city_id = date.city_id
      this.getData(date)
    })
  },
  methods: {
    getData (date) {
      let newDate = "";
      if (date) {
        newDate = date.region;
      } else {
        newDate = "永州市";
      }

      console.log(this.city_id);
      var date = null
      var dates = JSON.parse(localStorage.getItem("date"));
      dates.forEach((item, index) => {
        if (item.region == newDate) {
          date = item;
        }
      });

      console.log(date.flist, 'hhhhh');
      // 红色故事
      this.inherit_nameList = date.flist.map((item) => {
        return { "inherit_name": item.inherit_name, "burg_id": item.burg_id }
      })
      var newInherit_nameList = this.inherit_nameList.filter((item) => {
        return item.inherit_name != null
      })
      var newInherit_nameList2 = newInherit_nameList.filter((item) => {
        return item.inherit_name != ''
      })
      newInherit_nameList = newInherit_nameList2.filter((item) => {
        return item.inherit_name != '无'
      })
      this.inherit_nameList = newInherit_nameList
      console.log(this.inherit_nameList, '红色故事');

      // 团结故事
      this.unity_nameList = date.flist.map((item) => {
        return { "unity_name": item.unity_name, "burg_id": item.burg_id }
      })
      var newUnity_nameList = this.unity_nameList.filter((item) => {
        return item.unity_name != null
      })
      var newUnity_nameList2 = newUnity_nameList.filter((item) => {
        return item.unity_name != ''
      })
      newUnity_nameList = newUnity_nameList2.filter((item) => {
        return item.unity_name != '无'
      })
      this.unity_nameList = newUnity_nameList
      console.log(this.unity_nameList);

      // 当地传说
      this.folklore_nameList = date.flist.map((item) => {
        return { "folklore_name": item.folklore_name, "burg_id": item.burg_id }
      })
      var newFolklore_nameList = this.folklore_nameList.filter((item) => {
        return item.folklore_name != null
      })
      var newFolklore_nameList2 = newFolklore_nameList.filter((item) => {
        return item.folklore_name != ''
      })
      newFolklore_nameList = newFolklore_nameList2.filter((item) => {
        return item.folklore_name != '无'
      })
      this.folklore_nameList = newFolklore_nameList
      console.log(this.folklore_nameList);

      // 非遗
      this.relic_nameList = date.clist.map((item) => {
        return { "relic_name": item.relic_name, "burg_id": item.burg_id }
      })
      var newRelic_nameList = this.relic_nameList.filter((item) => {
        return item.relic_name != null
      })
      var newRelic_nameList2 = newRelic_nameList.filter((item) => {
        return item.relic_name != ''
      })
      newRelic_nameList = newRelic_nameList2.filter((item) => {
        return item.relic_name != '无'
      })
      this.relic_nameList = newRelic_nameList
      console.log(this.relic_nameList);

    },
    gushi (id) {
      console.log(id);
      // var date = JSON.parse(localStorage.getItem("date"))
      // console.log(date[this.city_id]);
      // bus.$emit('snackList', newSnackList.split('、'))
      this.$http.get('/api/ssm/Api/listBurg_counts', {
        params: { Burg_id: id },
      }).then((r) => {
        console.log(r.data.items[0].flist[0]);
        bus.$emit('mzgsBiao', r.data.items[0].flist[0])
      })
    },
    feiYi (id) {
      this.$http.get('/api/ssm/Api/listBurg_counts', {
        params: { Burg_id: id },
      }).then((r) => {
        console.log(r.data.items[0].clist[0]);
        bus.$emit('feiyiBiao', r.data.items[0].clist[0])
      })
    }
  },
}
</script>

<style lang="less" scoped>
.left_box {
  display: flex;
  width: 74%;
  height: 87vh;
  padding: 1vh;

  .box_1,
  .box_2,
  .box_3,
  .box_4 {
    position: relative;
    padding: 5vh;
    flex: 1;
    text-align: center;
    box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;
    -webkit-box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;

    .box_title {
      margin-bottom: 5vh;
      font-size: calc(100vw * 30 / 1920);
      font-weight: 1000;
      font-family: "黑体";
    }

    .box_txt {
      height: 67vh;
      overflow-y: scroll;
      overflow-x: hidden;
      ul {
        width: 70%;
        margin: auto;
        li {
          padding: 2vh 0;
          color: #000;
          border-bottom: 2px solid #666;
          font-size: calc(100vw * 20 / 1920);
        }
      }
    }

    .box_txt::-webkit-scrollbar {
      display: none;
    }
  }

  .box_2:before,
  .box_3:before,
  .box_4:before {
    content: "";
    position: absolute;
    left: 0;
    top: 10%;
    bottom: auto;
    right: auto;
    height: 80%;
    width: 5px;
    background-color: #61C9FF;
    
  }
}
</style>